var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2013 7.79616H18.4203V7.75593H9.69491V11.6339H15.174C14.3746 13.8914 12.2267 15.5119 9.69491 15.5119C6.4825 15.5119 3.87796 12.9073 3.87796 9.69491C3.87796 6.4825 6.4825 3.87796 9.69491 3.87796C11.1777 3.87796 12.5268 4.43736 13.554 5.35111L16.2962 2.6089C14.5647 0.995183 12.2486 0 9.69491 0C4.3409 0 0 4.3409 0 9.69491C0 15.0489 4.3409 19.3898 9.69491 19.3898C15.0489 19.3898 19.3898 15.0489 19.3898 9.69491C19.3898 9.04487 19.3229 8.41034 19.2013 7.79616Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69535 19.3899C12.1995 19.3899 14.4749 18.4316 16.1953 16.8731L13.1947 14.334C12.1887 15.0991 10.9593 15.5129 9.69535 15.5119C7.1737 15.5119 5.03258 13.904 4.22596 11.6602L1.06445 14.096C2.66896 17.2357 5.92742 19.3899 9.69535 19.3899Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2017 7.79658H18.4207V7.75635H9.69531V11.6343H15.1744C14.792 12.7087 14.1033 13.6475 13.1932 14.3348L13.1947 14.3339L16.1953 16.873C15.9829 17.0659 19.3902 14.5428 19.3902 9.69533C19.3902 9.04529 19.3233 8.41075 19.2017 7.79658Z",
    fill: "#1976D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11719 5.18241L4.30245 7.5184C5.16433 5.38455 7.25164 3.87796 9.69428 3.87796C11.1771 3.87796 12.5262 4.43736 13.5533 5.35111L16.2955 2.6089C14.564 0.995183 12.2479 0 9.69428 0C5.97046 0 2.74109 2.10234 1.11719 5.18241Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.776ab32bcfafe574a8b8da5d2bdfc2c4.svg";
export { ForwardRef as ReactComponent };